import { ChannelTypes } from 'types/ChatTypes';
import { HeaderRapper, ChatOrderSubHeader } from '../ChatHeaderStyle';
import { ProfileParamConverter } from 'utils/snippet';
import { ChatOrderHeaderIcon } from 'utils/SVGIcons';
import { getCustomerUrl } from 'constants/resource';
import ChatOptions from '../chatOption/ChatOptions';
import { useChatOrderStartModal } from 'hooks/useChatOrderStartModal';

export interface ChatHeaderBIZAProps {
  selectChannelobj: ChannelTypes;
  name: string | undefined;
  temperature: string | null;
  senderBaId: number;
  receiverId: number;
}

const ChatHeaderBIZA = ({
  selectChannelobj,
  name,
  temperature,
  senderBaId,
  receiverId,
}: ChatHeaderBIZAProps) => {
  const buyerId = String(receiverId);

  const { openChatOrderModal, isChatOrderButtonShow } = useChatOrderStartModal({
    baId: String(senderBaId),
    buyerId,
    buyerName: name ?? '(알 수 없음)',
    channelId: selectChannelobj.id,
  });

  return (
    <>
      <HeaderRapper className={isChatOrderButtonShow ? 'no-border' : ''}>
        <a
          href={getCustomerUrl({ baId: senderBaId, receiverId })}
          target="_blank"
          rel="noreferrer"
          className="chat-header-profile"
        >
          <img
            className="chat-header-image"
            src={ProfileParamConverter(selectChannelobj.receiver?.profileImage || '')}
            alt={name}
          />
          <div>
            <div className="main-title">
              <span className="biz-title">{name}</span>
              {temperature ? <span className="temperature">{`${temperature}°C`}</span> : null}
            </div>
          </div>
        </a>
        <ChatOptions selectChannelobj={selectChannelobj} />
      </HeaderRapper>
      {isChatOrderButtonShow && (
        <ChatOrderSubHeader>
          <button className="chat-order-button" onClick={openChatOrderModal}>
            <ChatOrderHeaderIcon />
            <span>채팅 주문</span>
          </button>
        </ChatOrderSubHeader>
      )}
    </>
  );
};

export default ChatHeaderBIZA;
